import { render, staticRenderFns } from "./BuildingEditFivePercentTab.vue?vue&type=template&id=2823a37f"
import script from "./BuildingEditFivePercentTab.vue?vue&type=script&lang=ts"
export * from "./BuildingEditFivePercentTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports